/* eslint-disable import/prefer-default-export */
import * as lc from '../../../../../utils/lodashCustom';

export function restructurePromotionalMaterialsModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    title: lc.get(data, 'title'),
    imgFile: lc.get(data, 'img_file'),
    imgFileSize: lc.get(data, 'img_file_size'),
    imgResolution: lc.get(data, 'img_resolution'),
    status: lc.get(data, 'status'),
    createdAt: lc.get(data, 'created_at'),
    updatedAt: lc.get(data, 'updated_at'),
    fileUrl: lc.get(data, 'url')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/promotionalMaterials/services/PromotionalMaterialsService/restructuring/index.js